import React, { useEffect, useLayoutEffect, useRef, useState } from '../../../../_snowpack/pkg/react.js';
import slug from '../../../../_snowpack/pkg/slugify.js';
import { useLazyQuery, useMutation } from '../../../../_snowpack/pkg/@apollo/react-hooks.js';
import * as Dialog from '../../../../_snowpack/pkg/@crystallize/react-dialog.js';
import { useTenant } from '../../../hooks/index.js';
import config from '../../../app-config.js';
import GuyWithDogSrc from '../../../images/illustrations/guy-with-dog.png'; // @ts-expect-error

import GTM from '../../../gtm.js';
import { COMPLETE_SIGNUP, SUGGEST_IDENTIFIER } from './graph.js';
import { Checkbox, Divider, Form, Heading, Illustration, Overlay, SubmitButton, TextField, Title, Wrapper } from './styles.js';
import TagSelect from './tag-select.js';

async function showDialog() {
  return await Dialog.showDialog({
    cleanTheme: true,
    body: /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '30px 50px'
      }
    }, /*#__PURE__*/React.createElement("h2", null, "Ouch!"), /*#__PURE__*/React.createElement("p", null, "Something went wrong when we tried to create your tenant."), /*#__PURE__*/React.createElement("p", null, "Please try again", ' ', /*#__PURE__*/React.createElement("a", {
      href: "/",
      onClick: Dialog.closeCurrent
    }, "manually"), ' ', "or ", /*#__PURE__*/React.createElement("a", {
      href: "mailto:hello@crystallize.com"
    }, "let us know"), " if you need any assistance"))
  });
}

function CompleteSignUp() {
  const {
    setTenant,
    user
  } = useTenant();
  const firstInput = useRef(null);
  const [companyIdentifier, setCompanyIdentifier] = useState(undefined);
  const [tag, setTag] = useState(undefined);
  const [getSuggestedIdentifier, {
    data,
    called
  }] = useLazyQuery(SUGGEST_IDENTIFIER, {
    onError: error => {
      console.error(`could not get a identifier suggestion`, error);
      showDialog();
    }
  });
  const [completeSignUp] = useMutation(COMPLETE_SIGNUP, {
    onError: error => {
      console.error(`could not complete the sign up`, error);
      showDialog();
    },
    onCompleted: data => {
      setTenant(data.tenant.create);
    }
  });
  useLayoutEffect(() => {
    const html = document.querySelector('html');
    html.style.overflow = 'hidden';
    return () => {
      html.style.overflow = 'auto';
    };
  });
  useEffect(() => {
    var _data$tenant, _data$tenant$suggestI;

    if (data !== null && data !== void 0 && (_data$tenant = data.tenant) !== null && _data$tenant !== void 0 && (_data$tenant$suggestI = _data$tenant.suggestIdentifier) !== null && _data$tenant$suggestI !== void 0 && _data$tenant$suggestI.suggestion) {
      setCompanyIdentifier(data.tenant.suggestIdentifier.suggestion);
    }
  }, [data]);

  const handleCompleteSignUp = async event => {
    var _first$trim, _first;

    event.preventDefault();
    const today = new Date().toISOString();
    const tocReadAt = today;
    const companyName = document.querySelector('#tenant-identifier').value;
    const name = document.querySelector('#user-name').value.trim();
    const marketingEmailConsentedAt = document.querySelector('#marketing').checked ? today : null;
    let first, last;

    if (/\s/.test(name)) {
      [first, ...last] = name.split(' ');
    }

    const firstName = (_first$trim = (_first = first) === null || _first === void 0 ? void 0 : _first.trim()) !== null && _first$trim !== void 0 ? _first$trim : name;

    if (called && companyIdentifier) {
      completeSignUp({
        variables: {
          companyName,
          companyIdentifier,
          tocReadAt,
          marketingEmailConsentedAt,
          ...(firstName.length && {
            firstName
          }),
          ...(last && {
            last: last.join(' ').trim()
          }),
          // the tag key will be used for the slack message in #crystallize-trial channel
          meta: [{
            key: 'tag',
            value: tag
          }]
        }
      });
      GTM.trigger.termsAgreed({
        hasAcceptedMarketing: marketingEmailConsentedAt,
        hasAcceptedTerms: true
      });
      GTM.trigger.tenantCreated();
    }
  };

  const handleIdentifierBlur = event => {
    const {
      value
    } = event.target;
    getSuggestedIdentifier({
      variables: {
        desired: slug(value)
      }
    });
  };

  const handleButtonKey = event => {
    if (event.key === 'Tab') {
      var _firstInput$current;

      event.preventDefault();
      (_firstInput$current = firstInput.current) === null || _firstInput$current === void 0 ? void 0 : _firstInput$current.focus();
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay, null), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Title, null, "Let's finalize your account"), /*#__PURE__*/React.createElement(Heading, null, "Now we have a way to authenticate you, but you still need a place to store all your stuff "), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleCompleteSignUp
  }, /*#__PURE__*/React.createElement(TextField, {
    htmlFor: "tenant-identifier"
  }, "Tenant identifier*", /*#__PURE__*/React.createElement("input", {
    "aria-required": true,
    autoFocus: true,
    id: "tenant-identifier",
    onBlur: handleIdentifierBlur,
    placeholder: "My company / concept / whatever",
    ref: firstInput,
    required: true,
    type: "text"
  })), /*#__PURE__*/React.createElement(TextField, {
    htmlFor: "user-name"
  }, "Your name (optional)", /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "user-name",
    placeholder: "Clark Kent"
  })), /*#__PURE__*/React.createElement(TextField, {
    htmlFor: "user-tag"
  }, "How do you plan to use Crystallize?*", /*#__PURE__*/React.createElement(TagSelect, {
    onSelect: setTag
  })), /*#__PURE__*/React.createElement(Checkbox, {
    htmlFor: "legal"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: "legal",
    id: "legal",
    required: true,
    "aria-required": true
  }), /*#__PURE__*/React.createElement("span", {
    className: "checkmark"
  }), "I do accept the", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://crystallize.com/legal-stuff",
    target: "_blank",
    rel: "noreferrer"
  }, "legal stuff"), ' ', "by using Crystallize*"), /*#__PURE__*/React.createElement(Checkbox, {
    htmlFor: "marketing"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: "marketing",
    id: "marketing"
  }), /*#__PURE__*/React.createElement("span", {
    className: "checkmark"
  }), "Send me the occasional mail so I am up to date (optional)"), /*#__PURE__*/React.createElement(SubmitButton, {
    disabled: !tag,
    onKeyDown: handleButtonKey
  }, "Finalize account")), /*#__PURE__*/React.createElement(Illustration, {
    src: GuyWithDogSrc,
    alt: "Guy with a dog"
  }), /*#__PURE__*/React.createElement("footer", null, user.email && /*#__PURE__*/React.createElement("p", null, "Logged in as ", user.email), /*#__PURE__*/React.createElement("a", {
    href: config.SIGN_OUT_URL
  }, "Sign in with a different account"))));
}

export default CompleteSignUp;